import { Swiper, Navigation, Pagination, Thumbs } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Thumbs]);

export default () => {
    var swiper = new Swiper('.gallery-modal-slider', {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
    });

    // componente de banner padrão
    let bannerDefault = new Swiper(".banner__default", {
        watchOverflow: true,
        navigation: {
            nextEl: '.banner-button-next',
            prevEl: '.banner-button-prev',
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let bannerHome = new Swiper(".banner__home", {
        watchOverflow: true,
        navigation: {
            nextEl: '.home-button-next',
            prevEl: '.home-button-prev',
        },
        pagination: {
            el: ".home-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let photosThumb = new Swiper(".photos-thumb", {
        spaceBetween: 16,
        slidesPerView: 4,
        freeMode: true,
        thumbsContainerClass: ".swiper-thumbs",
        slideThumbActiveClass: "swiper-slide-thumb-active",
        watchSlidesProgress: true,
    });

    let photos = new Swiper(".photos", {
        spaceBetween: 0,
        navigation: {
            nextEl: ".gallery-button-next",
            prevEl: ".gallery-button-prev",
        },
        pagination: {
            el: ".gallery-pagination",
            type: "bullets",
            clickable: true,
        },
        thumbs: {
            swiper: photosThumb,
        },
    });

    let contentVideo = new Swiper(".content-video", {
        spaceBetween: 0,
        navigation: {
            nextEl: ".content-button-next",
            prevEl: ".content-button-prev",
        },
        pagination: {
            el: ".content-pagination",
            type: "bullets",
            clickable: true,
        },
    });
};
